<template>
    <div>
        <!-- como incorporar lo siguiente a v-if (user.user_data.products ? user.user_data.products.sports : true) -->
        <div v-if="['gamanza_missions', 'gamanza_tournaments', 'gamanza_reward_shop'].includes(infoRouter?.category)"
            v-show="infoRouter?.active" :class="[iframeContainerClass, 'gamanza-widget-container']"
            :style="iframeContainerStyle">
            <gamanza-widget-page :key="infoRouter.category"
                :type="infoRouter.category === 'gamanza_missions' ? 'missions' : infoRouter.category === 'gamanza_tournaments' ? 'tournaments' : 'reward-shop'"
                :skin="selected_skin" />
        </div>
        <div v-else-if="infoRouter?.category !== 'espiral_app'" v-show="infoRouter?.active" :class="[iframeContainerClass, {
            'gamanza-sidebar-sports-visible': gamanzaSidebarVisible && isGamanzaSportsView,
            'gamanza-sidebar-open': gamanzaSidebarVisible && gamanzaSidebarExpanded
        }]" :style="iframeContainerStyle">

            <iframe ref="sportsIframe" id="sports_iframe" :src="urlview" allowfullscreen allow="fullscreen" :key="`${urlview}-${reloadIframe}`"
                scrolling="yes" style="width:100%; height:100%; border:none;" @load="handleIframeLoad"></iframe>
        </div>
        <div v-else :class="iframeContainerClass" :style="iframeContainerStyle">
            <EspiralApp :skin="selected_skin" :language="language" :user="user" />
        </div>
        <gamanza-sidebar :skin="selected_skin" :open="gamanzaSidebarVisible" @sidebar-expanded="gamanzaSidebarExpanded = $event" />
        <a v-if="selected_skin.whats_app_mainframe && selected_skin.whats_app_mainframe.enabled"
            :href="'https://api.whatsapp.com/send?phone=' + selected_skin.whats_app_mainframe.phone_number"
            id="whatsapp_btn" class="float btn" target="_blank" :style="finalStyle">
            <img id="whatsapp_logo" class="" src="../assets/images/whatsappBtn.png" alt="" width="45px">
        </a>
        <a v-if="selected_skin.telegram_mainframe && selected_skin.telegram_mainframe.enabled"
            :href="selected_skin.telegram_mainframe.url" id="whatsapp_btn" class="float btn" target="_blank"
            :style="screen_width > selected_skin.break_point ? 'bottom:45px;right:20px;position:fixed;z-index:9999;' : 'bottom: 68px;position: fixed;z-index: 9999;left: 5px;'">
            <img id="whatsapp_logo" class="" src="../assets/images/telegram.png" alt="" width="45px">
        </a>
    </div>
</template>

<script>
import EspiralApp from "../components/ganamos/payments/EspiralApp.vue";
import GamanzaSidebar from '@/components/gamanza/GamanzaSidebar.vue';
import GamanzaWidgetPage from '@/components/gamanza/GamanzaWidgetPage.vue';

export default {
    name: 'Main',
    components: {
        EspiralApp,
        GamanzaSidebar,
        GamanzaWidgetPage
    },
    data() {
        return {
            refreshHeight: 0,
            screen_width: 0,
            socialNetworksRetryTimeout: null,
            preconnectedIframeOrigins: [],
            pendingGamanzaGameName: '',
            gamanzaLaunchAwaitingResult: false,
            gamanzaSidebarOpen: false,
            gamanzaSidebarExpanded: false,
            gamanzaGameLaunchActive: false
        }
    },
    computed: {
        iframeContainerClass() {
            return this.selected_skin?.skin_type === 'landbased'
                ? 'holds-the-iframe-landbased'
                : 'holds-the-iframe';
        },
        iframeContainerStyle() {
            return {
                height: this.contentHeight,
                overflow: 'hidden',
                touchAction: "pan-y"
            }
        },
        finalStyle() {
            const baseStyle =
                this.screen_width > this.selected_skin.break_point
                    ? {
                        bottom: "45px",
                        right: "20px",
                        position: "fixed",
                        "z-index": 9999,
                    }
                    : {
                        bottom: "10px",
                        left: "5px",
                        position: "fixed",
                        "z-index": 9999,
                    };

            // Si hay customStyle, reemplaza por completo el baseStyle
            const customStyle = this.selected_skin?.whats_app_mainframe?.style;

            return customStyle && Object.keys(customStyle).length > 0
                ? customStyle
                : baseStyle;
        },
        domain() {
            return this.$store.getters['getDomain'];
        },
        infoRouter() {
            return this.$store.getters['getInfoRouter'];
        },
        gamanzaMainFrameSidebarEnabled() {
            return Boolean(
                this.selected_skin?.gamanza?.enabled &&
                this.selected_skin?.gamanza?.mainFrame?.sidebar
            );
        },
        gamanzaSidebarVisible() {
            return this.gamanzaMainFrameSidebarEnabled &&
                this.gamanzaSidebarOpen &&
                (this.isGamanzaSportsView || this.isGamanzaGameLaunch);
        },
        isGamanzaSportsView() {
            return ['sport', 'esport'].includes(this.infoRouter?.category);
        },
        isGamanzaGameLaunch() {
            return this.gamanzaGameLaunchActive;
        },
        urlview() {
            if (!this.infoRouter?.category || !this.infoRouter?.url) return '';
            if (this.infoRouter.category === 'espiral_app') return '';

            const { category, provider, url } = this.infoRouter;
            const token = this.user.token || this.user_demo?.token || '123456789';
            const site_id = this.user.site_id || this.user_demo?.site_id || '';
            const site = this.user.site || this.user_demo?.site || '';
            const user_id = this.user.user_data?.data?.user_id || this.user_demo?.user_data?.data?.user_id || '';
            const currency = this.user.user_data?.data?.currency || this.user_demo?.user_data?.data?.currency || '';
            const language = this.language || '';
            const domain1 = this.user.domain || '';
            const lobbyPlayerParam = this.selected_skin?.default_view === true && !user_id ? '&playerId=player_demo' : `&playerId=${user_id}_${site_id}`;

            switch (category) {
                case 'tonder':
                return `${url}&token=${token}&currency=${currency}&playerId=${user_id}_${site_id}`;
                case 'sport':
                    if (provider === 'jbetsv2') {
                        return `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}&url=${this.domain.split('admin.')[1]}`;
                    }
                    return provider !== 'jbets'
                        ? `${url}${this.user.token ? `&auth_token=${token}` : ''}&language=${language}`
                        : `${url}&token=${token}${site_id}&language=${language}`;
                case 'sportlive':
                    if (provider === 'jbetsv2') {
                        return `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}&url=${this.domain.split('admin.')[1]}`;
                    }
                    return `${url}&token=${token}${site_id}&language=${language}`;

                case 'esport':
                    return `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}&url=${this.domain.split('admin.')[1]}`;

                case 'lobby':
                    return `${url}&token=${(this.user.token ? this.user.token + this.user.site_id + '-' + this.user.site : '')}${lobbyPlayerParam}&language=${language}&currency=${currency}`;

                case 'casino':
                    let baseUrl = `${url}&token=${token}${site_id}-${site}${lobbyPlayerParam}&language=${language}&currency=${currency}`;
                    if (this.infoRouter?.id) {
                        let stringParamsArray = []
                        Object.keys(this.infoRouter.id).forEach(param => {
                            stringParamsArray.push(`${param}=${this.infoRouter.id[param]}`)
                        })
                        baseUrl += `&${stringParamsArray.join('&')}`; // Agrega el ID a la URL si existe
                    }
                    return baseUrl;
                case 'casino_live':
                    return `${url}&token=${token}${site_id}-${site}${lobbyPlayerParam}&language=${language}&currency=${currency}`;
                case 'virtuales':
                    if (provider === 'jbetsv2') {
                        return `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}&url=${this.domain.split('admin.')[1]}`;
                    }
                    return `${url}&token=${token}${site_id}&language=${language}`;
                case 'crazzywin':
                    return `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}`;
                case 'hipicas':
                    return provider !== 'jbets'
                        ? `${url}&tokenUser=${token}${site_id}&tokenClient=72b0fc93-fdd1-4c08-b1fd-0be81726a5d2&lang=es&cashierUrl=${domain1}&homeUrl=${domain1}`
                        : `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}&url=${this.domain.split('admin.')[1]}`;
                case 'quiniela':

                    return `${url}&token=${token}${site_id}-${site}&playerId=${user_id}_${site_id}&language=${language}&currency=${currency}&url=${this.domain.split('admin.')[1]}`;
                default:
                    return url;
            }
        },
        language() {
            return this.$store.getters['getLanguage'];
        },
        contentHeight() {
            this.refreshHeight;
            let header_height = this.$store.getters["getHeaderHeight"];
            let screen_height = document.documentElement.clientHeight;
            if (this.selected_skin.lobby) {
                return (screen_height - header_height) + "px";
            }
            else {
                return (screen_height - header_height - (this.selected_skin.skin_type === 'ganamos' && this.screen_width < 700 ? 70 : 0)) + "px";
            }
        },
        reloadIframe() {
            return this.$store.getters['getRechargeIframe']
        },
        headerHeight() {
            return this.$store.getters["getHeaderHeight"] + "px"
        },
        selected_skin() {
            return this.$store.getters['getCurrentSkin'];
        },
        // skin_charged() {
        //     return this.$store.getters['getSkinCharged'];
        // },
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        user_demo() {
            let data = this.$store.getters['getUserDataDemo'];
            return data;
        }
    },
    created() {
        this.sizeControl();
        this.checkToken();
    },
    mounted() {
        this.preconnectIframeHosts();
        window.addEventListener('resize', () => { this.sizeControl(); });
        window.addEventListener("message", (event) => {

            if (event.data?.type === 'gamanza-sidebar-state') {
                this.setGamanzaSidebarState(event);
                return;
            }

            if (['zeus-gamanza-launch-ready', 'gamanza-casino-launch-ready'].includes(event.data?.type)) {
                this.sendPendingGamanzaGameToCasino(event);
                return;
            }

            let view = event.data?.view;

            if (!view) {
                return;
            }

            if (view === 'refreshBalance') {
                if (this.selected_skin?.skin_type === 'landbased') {
                    this.checkToken();
                }
                return;
            }

            const viewMap = {
                "bingo": "esport",
                "crazywin": "crazzywin",
                "main": "sport"
            };
            view = viewMap[view] || view;

            const browsableCategories = this.selected_skin?.browsable_without_login || [];
            const alwaysRestrictedViews = ["openCasinoGame", "openCasinoGameFromLobby"];
            const restrictedViews = ["casino_live", "casino", "hipicas", "esport", "poker", "crazzywin"];

            const viewRequiresLogin = alwaysRestrictedViews.includes(view) ||
              (restrictedViews.includes(view) && !browsableCategories.includes(view));

            if (viewRequiresLogin && this.user.token === "") {
                this.$root.$emit('openLogin');
            }
            else if (view === 'openCasinoGame') {
                window.location.href = event.data.url;
            }
            else if (view === 'openCasinoGameFromLobby' && event?.data?.data) {
                this.$store.dispatch("changeView", event);
            }
            else {
                this.$store.dispatch("changeView", view);
            }

        }, false);
        this.$root.$on('gamanza-game-selected', this.sendGamanzaGameToCasino);
    },
    beforeDestroy() {
        this.$root.$off('gamanza-game-selected', this.sendGamanzaGameToCasino);
        if (this.socialNetworksRetryTimeout) {
            clearTimeout(this.socialNetworksRetryTimeout);
        }
    },
    methods: {
        preconnectIframeHosts() {
            const categories = this.selected_skin?.categories;

            if (!Array.isArray(categories)) {
                return;
            }

            categories.forEach(category => {
                if (!category?.active || !category?.url) {
                    return;
                }

                let origin = '';

                try {
                    origin = new URL(category.url, window.location.origin).origin;
                } catch {
                    return;
                }

                if (!origin || origin === window.location.origin || this.preconnectedIframeOrigins.includes(origin)) {
                    return;
                }

                this.preconnectedIframeOrigins.push(origin);

                const preconnect = document.createElement('link');
                preconnect.rel = 'preconnect';
                preconnect.href = origin;
                document.head.appendChild(preconnect);

                const dnsPrefetch = document.createElement('link');
                dnsPrefetch.rel = 'dns-prefetch';
                dnsPrefetch.href = origin;
                document.head.appendChild(dnsPrefetch);
            });
        },
        handleIframeLoad() {
            if (['sport', 'esport'].includes(this.infoRouter?.category)) {
                this.gamanzaSidebarOpen = true;
            }

            this.sendSocialNetworksToIframe();
            if (this.socialNetworksRetryTimeout) {
                clearTimeout(this.socialNetworksRetryTimeout);
            }
            this.socialNetworksRetryTimeout = setTimeout(() => {
                this.sendSocialNetworksToIframe();
            }, 500);
        },
        sendSocialNetworksToIframe() {
            const redes = this.selected_skin?.redes;
            const hasEnabledSocialNetworks = Object.values(redes || {}).some(red => red?.enabled);

            if (!hasEnabledSocialNetworks) {
                return;
            }

            const iframe = this.$refs.sportsIframe;
            if (!iframe || !iframe.contentWindow) {
                return;
            }

            const message = { socialNetworks: redes };
            iframe.contentWindow.postMessage(message, '*');
        },
        setGamanzaSidebarState(event) {
            if (!this.gamanzaMainFrameSidebarEnabled) return;

            const iframe = this.$refs.sportsIframe;
            if (!iframe?.contentWindow || !this.urlview || event.source !== iframe.contentWindow) {
                return;
            }

            let iframeOrigin = '';
            try {
                iframeOrigin = new URL(this.urlview, window.location.origin).origin;
            } catch {
                return;
            }

            if (event.origin === iframeOrigin && typeof event.data.open === 'boolean') {
                this.gamanzaSidebarOpen = event.data.open;
                this.gamanzaGameLaunchActive = event.data.open;
                if (event.data.open && this.gamanzaLaunchAwaitingResult) {
                    this.gamanzaLaunchAwaitingResult = false;
                }
                if (!event.data.open) {
                    this.gamanzaSidebarExpanded = false;
                }
            }
        },
        sendGamanzaGameToCasino(gameName) {
            if (!gameName) return;

            this.pendingGamanzaGameName = gameName;
            this.gamanzaLaunchAwaitingResult = true;
            this.gamanzaGameLaunchActive = true;
            this.gamanzaSidebarOpen = true;
            this.$store.dispatch('changeView', 'casino');
            this.$store.dispatch('setRechargeIframe');
        },
        sendPendingGamanzaGameToCasino(event) {
            const iframe = this.$refs.sportsIframe;
            if (!this.pendingGamanzaGameName || !iframe?.contentWindow || !this.urlview || event.source !== iframe.contentWindow) {
                return;
            }

            let zeusOrigin = '';
            try {
                zeusOrigin = new URL(this.urlview, window.location.origin).origin;
            } catch {
                return;
            }

            if (event.origin !== zeusOrigin) {
                return;
            }

            iframe.contentWindow.postMessage(
                { type: 'gamanza-game-selected', gameName: this.pendingGamanzaGameName },
                zeusOrigin
            );
            this.pendingGamanzaGameName = '';
        },
        async checkToken() {
            if (this.$store.getters['getUserData'].user_data.data && this.user.token != "" && this.selected_skin.skin_type !== 'altenar') {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
            }
        },
        sizeControl() {
            this.screen_width = window.innerWidth;
            this.refreshHeight++;
        }
    },
    watch: {
        infoRouter(newVal) {
            if (Array.isArray(newVal)) {
                console.warn("infoRouter no debería ser un array:", newVal);
                return;
            }
        },
        'selected_skin.redes': {
            handler() {
                this.$nextTick(() => {
                    this.sendSocialNetworksToIframe();
                });
            },
            deep: true
        },
        'selected_skin.categories': {
            handler() {
                this.$nextTick(() => {
                    this.preconnectIframeHosts();
                });
            },
            deep: true
        },
        'infoRouter.category'(category) {
            if (category !== 'casino') {
                this.gamanzaLaunchAwaitingResult = false;
                this.gamanzaGameLaunchActive = false;
            }
        },
        'infoRouter': {
            deep: true,
            handler(route, oldRoute) {
                const fromNonCasino = oldRoute?.category !== 'casino';
                if (route.category === 'casino' && !route.id && fromNonCasino && !this.gamanzaLaunchAwaitingResult) {
                    this.gamanzaGameLaunchActive = false;
                    this.gamanzaSidebarOpen = false;
                }
            }
        },

    }
}
</script>

<style>

.holds-the-iframe.gamanza-widget-container {
  background: #040713;
}

.holds-the-iframe.gamanza-sidebar-open,
.holds-the-iframe-landbased.gamanza-sidebar-open {
  margin-left: 390px;
  width: calc(100% - 390px);
  transition: margin-left 0.3s ease, width 0.3s ease;
}

.holds-the-iframe.gamanza-sidebar-sports-visible,
.holds-the-iframe-landbased.gamanza-sidebar-sports-visible {
  margin-left: 90px;
  width: calc(100% - 90px);
  transition: margin-left 0.3s ease, width 0.3s ease;
}

.holds-the-iframe.gamanza-sidebar-sports-visible.gamanza-sidebar-open,
.holds-the-iframe-landbased.gamanza-sidebar-sports-visible.gamanza-sidebar-open {
  margin-left: 390px;
  width: calc(100% - 390px);
}

@media (max-width: 767px) {
  .holds-the-iframe.gamanza-sidebar-open,
  .holds-the-iframe-landbased.gamanza-sidebar-open,
  .holds-the-iframe.gamanza-sidebar-sports-visible,
  .holds-the-iframe-landbased.gamanza-sidebar-sports-visible,
  .holds-the-iframe.gamanza-sidebar-sports-visible.gamanza-sidebar-open,
  .holds-the-iframe-landbased.gamanza-sidebar-sports-visible.gamanza-sidebar-open {
    margin-left: 0;
    width: 100%;
  }

  .holds-the-iframe-landbased {
    background-size: 30%;
  }
}
</style>
